import { HttpErrorResponse } from '@angular/common/http';
import { TileWidget } from '../../types/tile.types';

const WEATHER_CONDITIONS: Record<string, { label: string; icon: string }> = {
  'clear-day': { label: 'Sonnig', icon: 'ri-sun-line' },
  'clear-night': { label: 'Klar', icon: 'ri-moon-clear-line' },
  'partly-cloudy-day': { label: 'Leicht bewölkt', icon: 'ri-sun-cloudy-line' },
  'partly-cloudy-night': { label: 'Leicht bewölkt', icon: 'ri-moon-cloudy-line' },
  cloudy: { label: 'Bewölkt', icon: 'ri-cloudy-line' },
  fog: { label: 'Nebel', icon: 'ri-mist-line' },
  wind: { label: 'Windig', icon: 'ri-windy-line' },
  rain: { label: 'Regen', icon: 'ri-showers-line' },
  sleet: { label: 'Schneeregen', icon: 'ri-showers-line' },
  snow: { label: 'Schnee', icon: 'ri-snowy-line' },
  hail: { label: 'Hagel', icon: 'ri-hail-line' },
  thunderstorm: { label: 'Gewitter', icon: 'ri-thunderstorms-line' },
};

/** Beschreibung und Icon zum Wetter-Icon von Bright Sky (DWD-Daten). */
export function weatherCondition(icon: string): { label: string; icon: string } {
  return WEATHER_CONDITIONS[icon] ?? { label: 'Wechselhaft', icon: 'ri-cloud-line' };
}

/** „America/New_York“ → „New York“, leer → Ortszeit. */
export function timeZoneLabel(timeZone: string): string {
  return timeZone ? timeZone.split('/').pop()!.replaceAll('_', ' ') : 'Ortszeit';
}

/** Alle IANA-Zeitzonen des Browsers, sortiert nach Ortsname, für die Auswahl im Dialog. */
export function timeZoneOptions(): { label: string; value: string }[] {
  const zones = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : ['Europe/Berlin', 'Europe/London', 'America/New_York', 'Asia/Tokyo'];
  const options = zones.map(zone => ({ label: `${timeZoneLabel(zone)} (${zone.replaceAll('_', ' ')})`, value: zone }));
  options.sort((a, b) => a.label.localeCompare(b.label, 'de'));
  return [{ label: 'Ortszeit dieses Geräts', value: '' }, ...options];
}

/** Fehlertext vom Server (Hono liefert bei HTTPException den reinen Text). */
export function serverMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    if (typeof error.error === 'string' && error.error.trim() && error.error.length < 300) return error.error;
    if (typeof error.error?.message === 'string') return error.error.message;
  }
  return fallback;
}

/** Name, den der Server ohne eigene Angabe vergibt (server/src/tile/personal-widget.ts#widgetName). */
export function defaultWidgetName(widget: TileWidget): string {
  if (widget.type === 'weather') return `Wetter ${widget.place}`;
  if (widget.type === 'clock') return widget.timeZone ? `Uhr ${timeZoneLabel(widget.timeZone)}` : 'Uhr';
  return 'Notiz';
}
